import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Dra. Mariana Gutiérrez',
    age: 34,
    profession: 'Kinesióloga',
    city: 'Rosario',
    quote: 'Desde que implementé el Kit, mis pacientes notan la diferencia. Tengo todo organizado y mis seguimientos son impecables. Lo recomiendo al 100%.'
  }, {
    name: 'Dr. Facundo Herrera',
    age: 41,
    profession: 'Traumatólogo',
    city: 'Córdoba',
    quote: 'Llevaba años anotando todo en cuadernos. Este sistema me cambió la forma de trabajar. Ahora tengo datos concretos y mis pacientes mejoran más rápido.'
  }, {
    name: 'Lic. Sofía Peralta',
    age: 29,
    profession: 'Fisioterapeuta',
    city: 'Buenos Aires',
    quote: 'Como recién recibida, este kit me dio la estructura que necesitaba. Me siento mucho más segura en cada consulta.'
  }, {
    name: 'Dr. Alejandro Bustos',
    age: 38,
    profession: 'Médico Deportólogo',
    city: 'Mendoza',
    quote: 'La organización que te da este sistema es increíble. Mis pacientes deportistas ven resultados más rápido y yo trabajo con mucha más tranquilidad.'
  }, {
    name: 'Lic. Carolina Vega',
    age: 45,
    profession: 'Kinesióloga',
    city: 'Tucumán',
    quote: 'Tengo 20 años de experiencia y ojalá hubiera tenido esto antes. Simplificó todo mi trabajo y elevó mi nivel profesional.'
  }];
  return <section className="py-24 px-4 bg-slate-950 relative" data-id="element-217">
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-amber-900/10 blur-[100px] rounded-full pointer-events-none" data-id="element-218"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-219">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-220">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-221">
            Lo que dicen los profesionales
          </h2>
          <p className="text-xl text-slate-400" data-id="element-222">
            Colegas de toda Argentina ya transformaron su práctica.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-223">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-slate-900 p-8 rounded-2xl border border-slate-800 flex flex-col ${i === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-224">
              <div className="flex text-amber-400 mb-4" data-id="element-225">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-226" />)}
              </div>
              <Quote className="w-10 h-10 text-slate-800 mb-4" data-id="element-227" />
              <p className="text-slate-300 text-lg italic mb-6 flex-grow" data-id="element-228">
                "{t.quote}"
              </p>
              <div className="mt-auto pt-6 border-t border-slate-800" data-id="element-229">
                <p className="font-bold text-white text-lg" data-id="element-230">{t.name}</p>
                <p className="text-teal-400 font-medium" data-id="element-231">
                  {t.profession}, {t.age} años
                </p>
                <p className="text-slate-500 text-sm" data-id="element-232">{t.city}, Argentina</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}